import React, { Component } from 'react'
import ReactAutocomplete from 'react-autocomplete'
import { debounce } from '../../helpers/utility'

const styles = {
  highlighted: highlighted => ({
    backgroundColor: highlighted ? '#eee' : 'transparent',
    cursor: 'pointer'
  }),
  menuStyle: {
    direction: 'rtl',
    fontFamily: 'IranYekanRegular',
    padding: 10,
    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
    position: 'absolute',
    top: 35,
    left: 0,
    right: 0,
    zIndex: 10,
    backgroundColor: 'white',
    maxHeight: 300,
    overflowY: 'auto'
  },
  wrapperStyle: {
    width: '100%'
  }
}

export default class AutoCompleteInput extends Component {
  constructor(props) {
    super(props)
    this.state = { value: '' }
  }

  renderPred(item, value) {
    return item.name.includes(value)
  }

  getCurrentValue = () => {
    const { value } = this.state
    return value || this.props.value
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      if (typeof nextProps.value === 'object') {
        this.setState({
          value: nextProps.value.name
        })
      } else {
        this.setState({
          value: nextProps.value
        })
      }
    }
  }

  handleChange = event => {
    const value = event.target.value

    this.setState({ value })

    this.notifyParent(value)
  }

  notifyParent = debounce(value => {
    this.props.onTextChange && this.props.onTextChange(value)
  }, 400)

  rowRenderer = (item, highlighted) => (
    <div key={item.id} style={styles.highlighted(highlighted)}>
      {item.name}
    </div>
  )

  onSelect = (name, selectedItem) => {
    this.props.onChange(selectedItem)
    this.setState({ value: selectedItem.name })
  }

  componentDidUpdate = nextProps => {
    if (nextProps.value && nextProps.value !== this.props.value) {
      this.setState({ value: nextProps.value.name })
    }
  }

  renderInput = props => (
    <input
      {...props}
      value={props.value || ''}
      placeholder={this.props.placeholder}
      className="auto-complete-input"
      disabled={this.props.disabled}
    />
  )

  render() {
    const additionalStyles = this.props.styles || {}

    return (
      <ReactAutocomplete
        items={this.props.options}
        shouldItemRender={this.renderPred}
        getItemValue={item => item.name}
        renderItem={this.rowRenderer}
        value={this.getCurrentValue()}
        onChange={this.handleChange}
        onSelect={this.onSelect}
        autoHighlight
        wrapperStyle={styles.wrapperStyle}
        menuStyle={{ ...styles.menuStyle, ...additionalStyles }}
        renderInput={this.renderInput}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/AutoCompleteInput.js